module.exports = __webpack_public_path__ + "static/img/consultingCenter_1.41d93a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/consultingCenter_1.png
// module id = TTMM
// module chunks = 1